export default "__VITE_ASSET__DATqg7qw__"